import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditableTable from "components/Table/EditableTable";
import formService from "services/feedback-service";
import ConfirmationModal from "modals/miscellaneous/ConfirmationModal";

export default function ServicesTable({
  data,
  loadingState,
  updateTableFunction,
  setSelectedService, // Changed prop name
}) {
  const [rowToDelete, setRowToDelete] = useState(null);

  const [open, setOpen] = useState(false);
  const [promptResponse, setPromptResponse] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [submitKind, setSubmitKind] = useState("");
  const [promptDesc, setPromptDesc] = useState("");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (rowToDelete) {
      setPromptDesc("Are you sure you want to delete this data?");
      setSubmitKind("delete");
      setOpen(true);
    }
  }, [rowToDelete]);

  useEffect(() => {
    if (!open && submit && promptResponse) {
      setLoading(true);

      formService
        .deleteService(rowToDelete ? rowToDelete[0]?.id : "")
        .then(() => {
          setRowToDelete(null);
          setSubmit(false);
          updateTableFunction();
        })
        .catch((err) => {
          alert(err?.message);
          setRowToDelete(null);
          setSubmit(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [submit, promptResponse]);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "title",
      headerName: "Service",
      width: 500,
    },
    {
      field: "serviceKind",
      headerName: "Service Type",
      width: 150,
    },
    {
      field: "office",
      headerName: "Office",
      width: 500,
    },
    {
      field: "location",
      headerName: "Location",
      width: 500,
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <ConfirmationModal
        open={open}
        handleClose={() => setOpen(false)}
        setPromptResponse={setPromptResponse}
        setSubmit={setSubmit}
        submitKind={submitKind}
        promptDesc={promptDesc}
      />
      <EditableTable
        data={data}
        columns={columns}
        checkbox
        loading={loadingState || loading}
        singleSelect
        selectedData={setSelectedService} // Changed prop name
        rowToDelete={setRowToDelete}
        height="60vh"
        remove
      />
    </Box>
  );
}
